<template>
  <ul class="management-list">
    <li class="management-list-item" @click="changeValue(0)">
      Test Kit Management
    </li>
    <li class="management-list-item" @click="changeValue(4)">
      Outlier Kits
    </li>
    <li class="management-list-item" @click="changeValue(1)">
      Admin Management
    </li>
    <li class="management-list-item" @click="changeValue(2)">
      Lab Operator Management
    </li>
    <li class="management-list-item" @click="changeValue(3)">
      Research
    </li>
    <li class="management-list-item" @click="changeValue(23)">
      Research 2 (Map Analysis)
    </li>
    <li class="management-list-item" @click="changeValue(6)">
      QR Code Generator
    </li>
    <li class="management-list-item" @click="changeValue(7)">
      Kit URL Generator
    </li>
    <li class="management-list-item" @click="changeValue(8)">
      Customers
    </li>
    <li class="management-list-item" @click="changeValue(9)">
      Federal Holidays
    </li>
    <li class="management-list-item" @click="changeValue(11)">
      Woo Orders
    </li>
    <li class="management-list-item" @click="changeValue(12)">
      Import Kits from CSV
    </li>
    <li class="management-list-item" @click="changeValue(13)">
      Import Inactive CSV 
    </li>
    <li class="management-list-item" @click="changeValue(14)">
      Inventory Management 
    </li>

    <li class="management-list-item" @click="changeValue(16)">
      Amazon Inventory
    </li>
    <li class="management-list-item" @click="changeValue(17)">
      Sales
    </li>
    <li class="management-list-item" @click="changeValue(15)">
      Inventory
      
    </li>
  </ul>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ManagementList",
  props: ['showfilter','val'],
  methods: {
    ...mapActions(["setStatusFilter","setOverDueByShipped", "getAdminInfoList", "setAdminPginationPage", 
    "getLabOperatorInfoList","setAnalyticsHead","getPendingInfoList","getContactCustomers", "setCustomerCount", 
    "getFederalHolidays","getWooOrders", "setLoader", "resetState","sendSearchReqAnalytics","setInventory",
    "setLocations","setPage", "setFillocation","setFilItem","setItems","setInvKits","setAmazonFbaInv","setSalesData","setWooSalesData","getInactiveList"]),
    changeValue(val) {
      this.resetState();
      if (val === 0) {
        this.setStatusFilter([]);
        this.getAdminInfoList("kits").then(res => {
          this.$emit("title", { show: false, value: val });
        });
        this.$emit("showoutlinerfilters", { showfilter: true ,value: val});  
      } else if (val === 1) {
        this.setAdminPginationPage(null).then(() => {
          this.getAdminInfoList("admins").then(res => {
            this.$emit("title", { show: false, value: val });
          });
        });
      } else  if (val === 2) {
        this.setAdminPginationPage(null).then(() => {
          this.getLabOperatorInfoList("labOps").then(res => {
            this.$emit("title", { show: false, value: val });
          });
           });
      }  else  if (val === 3) {
          this.sendSearchReqAnalytics().then(res => {
            this.setAnalyticsHead({status:3,type:null,show:false,item:null,count:null,total:null});
            this.$emit("title", { show: false, value: val });
          });
      }  else  if (val === 4) {
           this.setOverDueByShipped(null);
           this.getPendingInfoList("pending").then(res => {
              this.$emit("title", { show: false, value: val });
            });
      }  else  if (val === 6) {
            this.$emit("title", { show: false, value: val });
      }  else if (val === 7) {
          this.$emit("title", { show: false, value: val });
      } else  if (val === 8) {
          this.setAdminPginationPage(null).then(() => {
            this.setCustomerCount(0).then(() => {
              this.getContactCustomers(null).then(res => {
                this.$emit("title", { show: false, value: val });
              });
            });
          });
      } else  if (val === 9) {
          this.getFederalHolidays().then(res => {
            this.$emit("title", { show: false, value: val });
          });
      } else  if (val === 11) {
          this.setLoader(true);
          this.getWooOrders().then(async res => {
            this.setLoader(false);
            this.$emit("title", { show: false, value: val });
          });
      } else  if (val === 12) {
        this.$emit("title", { show: false, value: val });
      } else  if (val === 13) {
          this.$emit("title", { show: false, value: val });
      } else  if (val === 14) {
          this.setLoader(true);
          this.setLocations();
          this.setItems();
          this.setFillocation('');
          this.setFilItem('');
          this.setInvKits(false);
          this.setPage(1).then(() => {
            this.setInventory().then(async res => {
              this.setLoader(false);
              this.$emit("title", { show: false, value: val });
            });
          });
      } else  if (val === 16) {
          this.setAmazonFbaInv();
          this.$emit("title", { show: false, value: val });
      } else  if (val === 17) {
          this.setSalesData();
          this.setWooSalesData();
          this.$emit("title", { show: false, value: val });
      } else  if (val === 15) {
        this.getInactiveList("kits").then(res => {
          this.$emit("title", { show: false, value: val });
        });
      }
    }
  }
};
</script>

<style scoped>
.management-list {
  position: absolute;
  left: 0;
  top: 40px;
  background-color: #fff;
  max-width: 412px;
  width: 100%;
  z-index: 2;
  border-radius:0px 0px 5px 5px;
  border: 1px solid #e7ecef;
  border-top: 0px;
  padding-top: 15px;
  margin-right: -10px;
}
.management-list-item {
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  width: 100%;
  padding: 10px 16px;
  cursor: pointer;
  color: #000;
  text-align: left;
}
.management-list-item:hover {
  background-color: #eee;
}
</style>
